var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_747_22588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.0429 16.954L1.04596 16.957C1.12707 17.0387 1.22352 17.1036 1.32978 17.1479C1.43604 17.1922 1.55001 17.215 1.66513 17.2151C1.762 17.2151 1.8582 17.1991 1.9499 17.1679L6.9423 15.4743L16.5224 5.89423C17.108 5.30853 17.437 4.51416 17.437 3.68588C17.437 2.8576 17.1079 2.06326 16.5222 1.4776C15.9365 0.891949 15.1421 0.562952 14.3138 0.562988C13.4856 0.563025 12.6912 0.892092 12.1056 1.4778L2.52548 11.0579L0.83207 16.0501C0.778727 16.2054 0.770213 16.3725 0.807503 16.5324C0.844793 16.6922 0.926377 16.8383 1.0429 16.954ZM12.9011 2.27328C13.2763 1.90095 13.7837 1.69247 14.3123 1.69348C14.8409 1.6945 15.3475 1.90493 15.7213 2.27869C16.0951 2.65246 16.3055 3.15911 16.3065 3.68769C16.3075 4.21627 16.099 4.72371 15.7267 5.09889L14.4669 6.35868L11.6412 3.53307L12.9011 2.27328ZM3.50669 11.6677L10.8458 4.32855L13.6714 7.15416L6.33227 14.4932L2.05607 15.9439L3.50669 11.6677Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_747_22588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.9dcafda60d115dbad6de2014c5d2f22b.svg";
export { ForwardRef as ReactComponent };